import { get } from '../shared/get';
import { Auth0Options } from '../shared/interfaces';
import { toFeedback } from '../shared/to-feedback';

import { createFeedbackElement } from './@dom/create-feedback-element';
import { getWidgetConfig } from './shared/get-widget-config';
import { loadIntegrations } from './shared/load-integrations';
import { request } from './shared/request';
import { getAuth0AuthenticatedClient } from './shared/setup-auth0';

class CurrentSubscriptionWidget extends HTMLElement {
    async connectedCallback() {
        const importing = loadIntegrations([`auth0`]);
        const elementsToRender = Array.from(this.querySelectorAll(`[data-mh]`));
        await importing;

        const feedback = createFeedbackElement(this);
        const widgetConfig = (await getWidgetConfig(this).catch((err) => {
            toFeedback([err.message], feedback);
            throw err;
        })) as Auth0Options;
        let accessToken: string | undefined;

        if (widgetConfig.auth0 !== false) {
            const auth0Client = await getAuth0AuthenticatedClient().catch((err) => {
                toFeedback([err.message], feedback);
                throw err;
            });
            accessToken = await auth0Client.getTokenSilently();
        }

        const getAccountResponse = await request({
            apiUrl: window.mh.apiUrl,
            endpoint: `/v1/programs/${window.mh.programSlug}/my-subscription`,
            method: `GET`,
            ...(accessToken && {
                headers: {
                    authorization: `Bearer ${accessToken}`,
                },
            }),
        });

        const json = await getAccountResponse.json();

        if (!getAccountResponse.ok) {
            throw new Error(json.error.message ?? json.error);
        }

        const formatter = new Intl.DateTimeFormat(undefined, {
            dateStyle: `medium`,
            timeStyle: `short`,
        });

        const userFriendlyJson = {
            ...json,
            activated_at: formatter.format(new Date(json.activated_at)),
            current_period_ends_at: formatter.format(new Date(json.current_period_ends_at)),
        };

        elementsToRender.forEach((element) => {
            const key = element.getAttribute(`data-mh`);
            if (!key) {
                return;
            }

            const value = get(userFriendlyJson, key);
            if (!value) {
                console.error(`Fix data-mh attribute, key "${key}" does not exist in "/my-account" response body.`);
                return;
            }

            element.replaceWith(value);
        });

        this.dispatchEvent(new Event(`mh-ready`));
    }
}

customElements.define(`mh-current-subscription`, CurrentSubscriptionWidget);

export default CurrentSubscriptionWidget;
